import { useState } from "react";
import { Loader2 } from "lucide-react";
import { StockTablePagination } from "../table/StockTablePagination";
import { DateFilter } from "./components/DateFilter";
import { InventoryTable } from "./components/InventoryTable";
import { useInventoryData } from "./hooks/useInventoryData";
import { StockItem } from "@/types/stock";

export const InventoryHistoryList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
  const itemsPerPage = 10;

  const { data, isLoading } = useInventoryData(selectedDate);
  const groupedInventories = data?.groupedInventories || {};
  const dates = Object.keys(groupedInventories);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Calculate pagination
  const totalPages = Math.ceil(dates.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentDates = dates.slice(startIndex, endIndex);

  const handleDateChange = (date: Date | undefined) => {
    setSelectedDate(date);
    setCurrentPage(1);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Historique des inventaires</h2>
        <DateFilter 
          selectedDate={selectedDate}
          onDateChange={handleDateChange}
        />
      </div>

      {currentDates.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          Aucun inventaire trouvé pour cette date
        </div>
      ) : (
        currentDates.map((date) => (
          <div key={date} className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-700">{date}</h3>
            <InventoryTable items={groupedInventories[date]} />
          </div>
        ))
      )}
      
      <StockTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};